export default __webpack_public_path__ + "static/hotblack-eventspace-433539e053846ab5447f3ecab6bdb9b6.pdf";